import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { SocketConnectionBase } from "./SocketConnectionBase";

export const SocketConnectionForce = () => {
    const params = useParams();

    // Leer parámetros de URL
    const attrs = useMemo(() => ({
        vtPusherAppId: params.pusherAppId || "",
        vtPusherKey: params.pusherKey || "",
        vtPusherSecret: params.pusherSecret || "",
        vtPusherCluster: params.pusherCluster || "eu",
        vtPusherChannel: params.pusherChannel || "",
        vtPusherEvent: params.pusherEvent || "",
    }), [params]);

    return (
        <SocketConnectionBase
            attrs={attrs}
            showTitle="📡 Socket Connection Monitor (Force Mode)"
        />
    );
};
